import { useContext, useEffect, useMemo } from 'preact/hooks';
import { EN_LANGUAGES } from '../../constants/languages';
import { AllyFeaturesActions } from './use-ally-features';
import { ApplicationContext } from '../../services/use-application-setup';

const DICTIONARY_FEATURE_KEY = 's21';

enum DICTIONARY_ACTION_STATE {
  DISABLED = 0,
  ENABLED = 1,
}

export const useDictionaryAvailability = ({allyFeaturesList, allyFeaturesState, allyFeatureDispatch}) => {
  const { language } = useContext(ApplicationContext);

  const featuresListLoaded = useMemo(() => allyFeaturesList?.length, [allyFeaturesList]);
  const isDictionaryFeatureAvailable = useMemo(() => !!allyFeaturesState[DICTIONARY_FEATURE_KEY], [allyFeaturesState]);

  useEffect(() => {
    if (!language || !featuresListLoaded || !isDictionaryFeatureAvailable) {
      return;
    }

    const dictionaryEnabled = EN_LANGUAGES.find((lang) => lang === language);
    const isDictionaryOn = allyFeaturesState[DICTIONARY_FEATURE_KEY].actionState;
    // disable Dictionary feature for non-English language
    allyFeatureDispatch(
      AllyFeaturesActions.update({
        name: DICTIONARY_FEATURE_KEY,
        actionState: dictionaryEnabled && isDictionaryOn? DICTIONARY_ACTION_STATE.ENABLED: DICTIONARY_ACTION_STATE.DISABLED,
        temporaryDisabled: dictionaryEnabled ? false : { reason: '' },
      }),
    );
  }, [language, featuresListLoaded, isDictionaryFeatureAvailable]);
}
